import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { Check, Loader2, XCircle } from "lucide-react";
import { API, RESTAURANT } from "../data/site";

const OrderSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          localStorage.removeItem("sde_cart");
          setState("paid");
          return;
        }
        if (res.data.payment_status === "failed") { setState("failed"); return; }
      } catch { /* keep polling */ }
      tries.current += 1;
      if (tries.current < 12) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5 text-white" data-testid="order-success-page">
      <div className="glass max-w-md rounded-3xl p-10 text-center">
        {state === "checking" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-gold" />
            <h1 className="mt-6 font-serif text-3xl">Confirming your payment…</h1>
            <p className="mt-3 text-sm text-mist">This takes a few seconds.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold/15">
              <Check size={30} className="text-gold" />
            </span>
            <h1 className="mt-6 font-serif text-4xl" data-testid="order-confirmed-title">Order confirmed</h1>
            <p className="mt-4 leading-relaxed text-mist">
              Payment received. The tawa is already heating up — we'll text or call
              you at your number when it's ready for pickup.
            </p>
            <p className="mt-3 text-sm text-white/50">{RESTAURANT.address1}, {RESTAURANT.address2}</p>
            <a href="/" data-testid="success-home-link" className="btn-gold mt-8 inline-block rounded-full px-8 py-3.5 text-[12px] font-semibold uppercase tracking-[0.2em]">
              Back to Home
            </a>
          </>
        )}
        {(state === "failed" || state === "timeout") && (
          <>
            <XCircle size={40} className="mx-auto text-red-400" />
            <h1 className="mt-6 font-serif text-3xl">
              {state === "timeout" ? "Still confirming…" : "Payment not completed"}
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-mist">
              {state === "timeout"
                ? "Your payment is taking longer than usual to confirm. If you were charged, call us and we'll locate your order."
                : "No charge was made. You can try again or order by phone."}
            </p>
            <div className="mt-8 flex justify-center gap-3">
              <a href="/order" data-testid="retry-order-link" className="btn-gold rounded-full px-6 py-3 text-[12px] font-semibold uppercase tracking-[0.18em]">Try Again</a>
              <a href={RESTAURANT.phoneHref} data-testid="success-call-link" className="btn-ghost rounded-full px-6 py-3 text-[12px] uppercase tracking-[0.18em]">Call Us</a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OrderSuccess;
